export function loadLocalizers(manifest, requestedLocales) {
    const defaultEntry = manifest[''];
    if (defaultEntry === undefined) {
        throw new Error();
    }
    const translatedLocales = Object.keys(manifest);
    const locales = getLocales(requestedLocales, translatedLocales);
    if (defaultEntry instanceof Function) {
        const promises = locales
            .map((locale) => manifest[locale])
            .map((load) => load());
        return Promise.all(promises).then((results) => {
            const bundles = results.map((result) => result.default);
            return Object.assign({}, ...bundles);
        });
    }
    else {
        const bundles = locales.map((locale) => manifest[locale]);
        return Object.assign({}, ...bundles);
    }
}
// We need to know the language included in the default bundle so that we can differentiate
// between a user who prefers the default language (fallback chaain looks like ['']) and a user
// who prefers a language for which we do not have a translation (fallback chain looks like [''])
const DEFAULT_BUNDLE_LANGUAGE = 'en';
function getLocales(requestedLocales, translatedLocales) {
    // Even though we do not have an explicit translation for it, the default language is available.
    const availableLocales = translatedLocales.concat([DEFAULT_BUNDLE_LANGUAGE]);
    // start with the passed in BCP 47 strings
    const matchingLocaleLists = requestedLocales.map((locale) => {
        // check hard-coded overrides
        locale = FallbackOverrides[locale] || locale;
        // consider all fallbacks based on substring
        const comparator = (first, second) => isCompatibleFallback(first, second) ? 1 : -1;
        return availableLocales.filter((al) => isCompatibleFallback(locale, al)).sort(comparator);
    });
    // Each of these is a list of fallback chains,
    // like [['en-US', 'en', ''], ['es-SV', 'es', '']]
    const usableLocaleLists = matchingLocaleLists.filter((list) => list.length > 0);
    const translatedLocaleLists = matchingLocaleLists.filter((list) => list.length > 1);
    // locales is a single chain of fallbacks for a single language,
    // like ['he-IL-jeruslm', 'he-IL', 'he', '']
    let locales = [];
    if (translatedLocaleLists.length > 0) {
        // Ideally, we use the first set of locales for which we have a real (non-default) translation
        locales = translatedLocaleLists[0];
    }
    else if (usableLocaleLists.length > 0) {
        // Otherwise, the default is fine.
        locales = usableLocaleLists[0];
    }
    else {
        // NOTE: this only happens if this code has a bug or you do not have a root locale loader (locale: '') set.
        throw new Error(`Could not find a loader for locales: ${requestedLocales}`);
    }
    // Filter out the default because we do not have a loader for it
    return locales.filter((locale) => locale !== DEFAULT_BUNDLE_LANGUAGE);
}
/**
 * A candidate is a compatible fallback for a locale if the locale is composed of the candidate,
 * followed by a hyphen or underscore, followed by other characters, or if the candidate is ''.
 * So 'en' is a fallback for 'en-US' or 'en_US', but not for 'enx' (if that were real).
 */
function isCompatibleFallback(locale, candidate) {
    locale = locale.replace(/\_/g, '-');
    candidate = candidate.replace(/\_/g, '-');
    if (candidate === '' || locale === candidate) {
        return true;
    }
    if (!locale.startsWith(candidate)) {
        return false;
    }
    const charAfterMatch = locale[candidate.length];
    return charAfterMatch === '-';
}
// NOTE: these are hardcoded fallbacks for certain langs.
// TODO: allow consuming code to feed this in? or should we just take a function instead?
const FallbackOverrides = {
    // Chinese should default to simplified characters
    zh: 'zh-Hans',
    'zh-CN': 'zh-Hans',
    // Hong Kong and Taiwan use traditional characters
    'zh-HK': 'zh-Hant',
    'zh-TW': 'zh-Hant',
};
//# sourceMappingURL=I18nLoader.js.map